import React, { useContext } from "react"
import { motion } from "framer-motion"
import { isMobileContext } from "../context/isMobileContext"
import Community from "../../pages/community"
export default function Privacy({
	data,
	invertedSection,
	uniqueClass,
	noPaddingStart,
	noPaddingEnd,
	privacySection,
	safetySection,
	employmentSection,
	environmentSection,
	privacyLayer1,
	privacyLayer2,
	volunteeringSection,
	environmentLayer,
	SocialResponsibility,
	WomenSection,
	HumenRight,
	SupportSection,
	airQuailty,
	contribution,
	biodiversity,
	qualityData,
	environmentMobileLayer,
	labourSection,
	lawsSection,
	desktopLayer,
	climate,
	markerOnly,
	normalSwiperLayers, marker,
	removeImg,
	communityPage,
	environmentLayer2,environmentBg

}) {
	const { isMobile } = useContext(isMobileContext)
	return (
		<div
			className={`privacy-section 
			${uniqueClass}
			${invertedSection ? "invertedSection" : ""} 
			${noPaddingStart ? "noPaddingStart" : ""} 
			${noPaddingEnd ? "noPaddingEnd" : ""} 
			${safetySection ? "safetySection" : ""}
			${environmentSection ? "environmentSection" : ""}
			${privacySection ? "privacySection" : ""} 
			${employmentSection ? "employmentSection" : ""} 
			${privacyLayer1 ? "privacyLayer1" : ""} 
			${privacyLayer2 ? "privacyLayer2" : ""} 
			${environmentLayer ? "environmentLayer" : ""} 
			${environmentMobileLayer ? "environmentMobileLayer" : ""} 
			${marker ? "marker" : ""} 
			${desktopLayer ? "desktopLayer" : ""} 
			${volunteeringSection ? "volunteeringSection" : ""} 
			${SocialResponsibility ? "SocialResponsibility" : ""}
			${WomenSection ? "WomenSection" : ""}
			${HumenRight ? "HumenRight" : ""}
			${WomenSection ? "WomenSection" : ""}
			${SupportSection ? "SupportSection" : ""} 
			${qualityData ? "qualityData" : ""} 
			${contribution ? "contribution" : ""} 
			${labourSection ? "labourSection" : ""} 
			${lawsSection ? "lawsSection" : ""} 
			${climate ? "climate" : ""} 
			${normalSwiperLayers ? "normalSwiperLayers" : ""} 
			${communityPage ? "communityPage" : ""} 
			${environmentLayer2 ? "environmentLayer2" : ""} 
			`}
		>
			<div className="info">
				<div className="header">
					<div className="first-line">
						<motion.h3
							initial={{ opacity: 0, translateY: "100%" }}
							whileInView={{ opacity: 1, translateY: 0 }}
							viewport={{ once: true }}
							transition={{ ease: "easeInOut", duration: 0.7, delay: 0.25 }}
						>
							{data.line1}
						</motion.h3>
					</div>
					{data.line2 && (
						<div className="second-line">
							<motion.h3
								initial={{ opacity: 0, translateY: "100%" }}
								whileInView={{ opacity: 1, translateY: 0 }}
								viewport={{ once: true }}
								transition={{
									ease: "easeInOut",
									duration: 0.7,
									delay: 0.5,
								}}
							>
								{data.line2}
							</motion.h3>
						</div>
					)}
					{data.line3 && (
						<div className="third-line">
							<motion.h3
								initial={{ opacity: 0, translateY: "100%" }}
								whileInView={{ opacity: 1, translateY: 0 }}
								viewport={{ once: true }}
								transition={{
									ease: "easeInOut",
									duration: 0.7,
									delay: 0.75,
								}}
							>
								{data.line3}
							</motion.h3>
						</div>
					)}
				</div>
				<div className="desc">
					{data.descriptions.map((item, index) => (
						<motion.p
							initial={{ opacity: 0 }}
							whileInView={{ opacity: 1 }}
							viewport={{ once: true }}
							transition={{
								ease: "easeInOut",
								duration: 0.5,
								delay: 0.75 + parseFloat(index * 0.05),
							}}
							key={index}
						>
							{item}
						</motion.p>
					))}
				</div>
			</div>
			<motion.div
				initial={{ opacity: 0 }}
				whileInView={{ opacity: 1 }}
				viewport={{ once: true }}
				transition={{ ease: "easeInOut", duration: 0.7, delay: 1 }}
				className={`img-container ${airQuailty && "translate-img"} 
				${contribution && "contribution"}
				${biodiversity && "biodiversity"}
				`}
			>
				{!removeImg && <img
					src={process.env.PUBLIC_URL + data.img}
					alt="privacy-illustrated-img"
				/>}
			</motion.div>
			{/* {safetySection && ( */}
			{privacyLayer2 && (
				<div className="back-layer3">
					<img
						src={process.env.PUBLIC_URL + "/imgs/achievements/back-layer3.png"}
						alt="back-layer5"
					/>
				</div>
			)}
			{/* {privacySection && ( */}
			{privacyLayer1 && (
				<>
					<div className="back-layer4">
						<img
							src={
								process.env.PUBLIC_URL +
								"/imgs/home-page/statement-back-layer4.svg"
							}
							alt="back-layer"
						/>
					</div>
					{/* <div className="back-layer4">
						<img
							src={
								process.env.PUBLIC_URL + "/imgs/achievements/back-layer4.png"
							}
							alt=""
						/>
					</div> */}
				</>
			)}
			{/* {safetySection && ( */}
			{privacyLayer2 && !markerOnly && (
				<div className="back-layer-line">
					<img
						src={process.env.PUBLIC_URL + "/imgs/home-page/vector-bg.png"}
						alt="bg"
					/>
				</div>
			)}
			{environmentLayer && (
				<div className="back-layer-line">
					<img
						src={process.env.PUBLIC_URL + "/imgs/home-page/vector-bg.png"}
						alt="bg"
					/>
				</div>
			)}
			{environmentMobileLayer && (
				<div className={`mobile-bg
				${environmentBg?"environmentBg":""}
				`}>
					<img
						src={process.env.PUBLIC_URL + '/imgs/appendices/partners-bg2.png'}
						alt='background'
					/>
				</div>
			)}
			{desktopLayer &&
				<div className="desktop-bg">
					<img
						src={
							process.env.PUBLIC_URL + "/imgs/appendices/partners-bg2.png"
						}
						alt=""
					/>
				</div>
			}
			{normalSwiperLayers && (
				<div className="bg">
					<img
						src={
							process.env.PUBLIC_URL +
							"/imgs/home-page/statement-back-layer4.svg"
						}
						alt="back-layer"
					/>
				</div>
			)}
			{communityPage && (
				<>
					<div className="bg-mobile-page">
						<img
							src={
								process.env.PUBLIC_URL + "/imgs/achievements/back-layer4.png"
							}
							alt="back_layer"
						/>
					</div>
				</>
			)}
			{environmentLayer2 ? (
					<>
						<div className="back-layer4">
							<img
								src={
									process.env.PUBLIC_URL +
									"/imgs/home-page/statement-back-layer4.svg"
								}
								alt="back-layer"
							/>
						</div>
						<div className="back-layer4 bg2">
							<img
								src={
									process.env.PUBLIC_URL + "/imgs/achievements/back-layer4.png"
								}
								alt=""
							/>
						</div>
					</>
				) : ""}
		</div>
	)
}
